/** Undefined when the url is already on the retailer's subdomain or isn't on a loyalty host. */
export const getRetailerSubdomainUrl = (
  currentUrl: string,
  shortUrlName: string | null | undefined,
  shortUrlDomain: string,
): string | undefined => {
  const url = new URL(currentUrl);
  if (!shortUrlName || !url.hostname.endsWith(`.${shortUrlDomain}`)) {
    return undefined;
  }

  const [subdomain, ...restOfHostname] = url.hostname.split('.');
  if (subdomain.toLowerCase() === shortUrlName.toLowerCase()) {
    return undefined;
  }

  url.hostname = [shortUrlName.toLowerCase(), ...restOfHostname].join('.');
  return url.toString();
};
